import '@collectivehealth/dls-icons/dist/es/elements/dls-icon-arrow-left.js';
import '@collectivehealth/dls-icons/dist/es/elements/dls-icon-arrow-right.js';
import '@collectivehealth/dls-icons/dist/es/elements/dls-icon-external-link-small.js';
import { addStyles } from '@collectivehealth/dls-icon-label';
import { StyleUtilities } from '@collectivehealth/dls-styles';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _CustomElement() {
  return Reflect.construct(HTMLElement, [], this.__proto__.constructor);
}

Object.setPrototypeOf(_CustomElement.prototype, HTMLElement.prototype);
Object.setPrototypeOf(_CustomElement, HTMLElement);

function noop() {}

function run(fn) {
  return fn();
}

function blank_object() {
  return Object.create(null);
}

function run_all(fns) {
  fns.forEach(run);
}

function is_function(thing) {
  return typeof thing === 'function';
}

function safe_not_equal(a, b) {
  return a != a ? b == b : a !== b || a && _typeof(a) === 'object' || typeof a === 'function';
}

function append(target, node) {
  target.appendChild(node);
}

function insert(target, node, anchor) {
  target.insertBefore(node, anchor || null);
}

function detach(node) {
  node.parentNode.removeChild(node);
}

function element(name) {
  return document.createElement(name);
}

function text(data) {
  return document.createTextNode(data);
}

function space() {
  return text(' ');
}

function empty() {
  return text('');
}

function listen(node, event, handler, options) {
  node.addEventListener(event, handler, options);
  return function () {
    return node.removeEventListener(event, handler, options);
  };
}

function attr(node, attribute, value) {
  if (value == null) node.removeAttribute(attribute);else if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
}

function set_custom_element_data(node, prop, value) {
  if (prop in node) {
    node[prop] = value;
  } else {
    attr(node, prop, value);
  }
}

function children(element) {
  return Array.from(element.childNodes);
}

function set_data(text, data) {
  data = '' + data;
  if (text.data !== data) text.data = data;
}

var current_component;

function set_current_component(component) {
  current_component = component;
}

var dirty_components = [];
var binding_callbacks = [];
var render_callbacks = [];
var flush_callbacks = [];
var resolved_promise = Promise.resolve();
var update_scheduled = false;

function schedule_update() {
  if (!update_scheduled) {
    update_scheduled = true;
    resolved_promise.then(flush);
  }
}

function add_render_callback(fn) {
  render_callbacks.push(fn);
}

function flush() {
  var seen_callbacks = new Set();

  do {
    // first, call beforeUpdate functions
    // and update components
    while (dirty_components.length) {
      var component = dirty_components.shift();
      set_current_component(component);
      update(component.$$);
    }

    while (binding_callbacks.length) {
      binding_callbacks.pop()();
    } // then, once components are updated, call
    // afterUpdate functions. This may cause
    // subsequent updates...


    for (var i = 0; i < render_callbacks.length; i += 1) {
      var callback = render_callbacks[i];

      if (!seen_callbacks.has(callback)) {
        callback(); // ...so guard against infinite loops

        seen_callbacks.add(callback);
      }
    }

    render_callbacks.length = 0;
  } while (dirty_components.length);

  while (flush_callbacks.length) {
    flush_callbacks.pop()();
  }

  update_scheduled = false;
}

function update($$) {
  if ($$.fragment !== null) {
    $$.update();
    run_all($$.before_update);
    var dirty = $$.dirty;
    $$.dirty = [-1];
    $$.fragment && $$.fragment.p($$.ctx, dirty);
    $$.after_update.forEach(add_render_callback);
  }
}

var outroing = new Set();

function transition_in(block, local) {
  if (block && block.i) {
    outroing.delete(block);
    block.i(local);
  }
}

function mount_component(component, target, anchor) {
  var _component$$$ = component.$$,
      fragment = _component$$$.fragment,
      on_mount = _component$$$.on_mount,
      on_destroy = _component$$$.on_destroy,
      after_update = _component$$$.after_update;
  fragment && fragment.m(target, anchor); // onMount happens before the initial afterUpdate

  add_render_callback(function () {
    var new_on_destroy = on_mount.map(run).filter(is_function);

    if (on_destroy) {
      on_destroy.push.apply(on_destroy, _toConsumableArray(new_on_destroy));
    } else {
      // Edge case - component was destroyed immediately,
      // most likely as a result of a binding initialising
      run_all(new_on_destroy);
    }

    component.$$.on_mount = [];
  });
  after_update.forEach(add_render_callback);
}

function destroy_component(component, detaching) {
  var $$ = component.$$;

  if ($$.fragment !== null) {
    run_all($$.on_destroy);
    $$.fragment && $$.fragment.d(detaching); // TODO null out other refs, including component.$$ (but need to
    // preserve final state?)

    $$.on_destroy = $$.fragment = null;
    $$.ctx = [];
  }
}

function make_dirty(component, i) {
  if (component.$$.dirty[0] === -1) {
    dirty_components.push(component);
    schedule_update();
    component.$$.dirty.fill(0);
  }

  component.$$.dirty[i / 31 | 0] |= 1 << i % 31;
}

function init(component, options, instance, create_fragment, not_equal, props) {
  var dirty = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [-1];
  var parent_component = current_component;
  set_current_component(component);
  var prop_values = options.props || {};
  var $$ = component.$$ = {
    fragment: null,
    ctx: null,
    // state
    props: props,
    update: noop,
    not_equal: not_equal,
    bound: blank_object(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    before_update: [],
    after_update: [],
    context: new Map(parent_component ? parent_component.$$.context : []),
    // everything else
    callbacks: blank_object(),
    dirty: dirty
  };
  var ready = false;
  $$.ctx = instance ? instance(component, prop_values, function (i, ret) {
    var value = (arguments.length <= 2 ? 0 : arguments.length - 2) ? arguments.length <= 2 ? undefined : arguments[2] : ret;

    if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
      if ($$.bound[i]) $$.bound[i](value);
      if (ready) make_dirty(component, i);
    }

    return ret;
  }) : [];
  $$.update();
  ready = true;
  run_all($$.before_update); // `false` as a special case of no DOM component

  $$.fragment = create_fragment ? create_fragment($$.ctx) : false;

  if (options.target) {
    if (options.hydrate) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      $$.fragment && $$.fragment.l(children(options.target));
    } else {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      $$.fragment && $$.fragment.c();
    }

    if (options.intro) transition_in(component.$$.fragment);
    mount_component(component, options.target, options.anchor);
    flush();
  }

  set_current_component(parent_component);
}

var SvelteElement;

if (typeof HTMLElement === 'function') {
  SvelteElement =
  /*#__PURE__*/
  function (_CustomElement2) {
    _inherits(SvelteElement, _CustomElement2);

    function SvelteElement() {
      var _this;

      _classCallCheck(this, SvelteElement);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(SvelteElement).call(this));

      _this.attachShadow({
        mode: 'open'
      });

      return _this;
    }

    _createClass(SvelteElement, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        // @ts-ignore todo: improve typings
        for (var key in this.$$.slotted) {
          // @ts-ignore todo: improve typings
          this.appendChild(this.$$.slotted[key]);
        }
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(attr, _oldValue, newValue) {
        this[attr] = newValue;
      }
    }, {
      key: "$destroy",
      value: function $destroy() {
        destroy_component(this, 1);
        this.$destroy = noop;
      }
    }, {
      key: "$on",
      value: function $on(type, callback) {
        // TODO should this delegate to addEventListener?
        var callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
        callbacks.push(callback);
        return function () {
          var index = callbacks.indexOf(callback);
          if (index !== -1) callbacks.splice(index, 1);
        };
      }
    }, {
      key: "$set",
      value: function $set() {// overridden by instance, if it has props
      }
    }]);

    return SvelteElement;
  }(_CustomElement);
}

var styles = ":host([disable]){pointer-events:none}dls-arrow-link[disable],dls-link[disable]{pointer-events:none}";
var iconLabelGlyph = "mc56d90362_iconLabelGlyph";
var styles$1 = ".mc56d90362_iconLabelGlyph{position:relative;top:-1px}";
var iconLabelGlyph$1 = "mca8d7d398_iconLabelGlyph";
var styles$2 = ".mca8d7d398_iconLabelGlyph{position:relative;top:-2px}";
var link = {
  "link": "mcdd17991f_link",
  "linkIconLabel": "mcdd17991f_linkIconLabel",
  "linkLabel": "mcdd17991f_linkLabel",
  "disabled": "mcdd17991f_disabled",
  "underlined": "mcdd17991f_underlined",
  "bold": "mcdd17991f_bold",
  "standalone": "mcdd17991f_standalone"
};
var link$1 = "mcdd17991f_link";
var linkIconLabel = "mcdd17991f_linkIconLabel";
var linkLabel = "mcdd17991f_linkLabel";
var disabled = "mcdd17991f_disabled";
var underlined = "mcdd17991f_underlined";
var bold = "mcdd17991f_bold";
var standalone = "mcdd17991f_standalone";
var styles$3 = ":host{display:inline-flex}dls-link{display:inline-flex}[data-style]{display:none}.mcdd17991f_link{border:0;line-height:inherit;margin:0;padding:0;vertical-align:baseline}.mcdd17991f_link,.mcdd17991f_link:visited{color:#007e8c;cursor:pointer;font:inherit}.mcdd17991f_link,.mcdd17991f_link slot{display:block}a.mcdd17991f_link,a.mcdd17991f_link:visited{text-decoration:none}button.mcdd17991f_link{background-color:transparent;border:0;margin:0;overflow:visible;padding:0}.mcdd17991f_link:focus{outline:none}.mcdd17991f_link:active,.mcdd17991f_link:focus,.mcdd17991f_link:hover{color:#006373}.mcdd17991f_link[disabled]{color:inherit!important;cursor:default!important;pointer-events:none!important}.mcdd17991f_linkIconLabel{display:block}.mcdd17991f_linkLabel{display:block;position:relative;z-index:0}.mcdd17991f_linkLabel:after{border:solid transparent;border-width:0 0 1px;border-image-slice:0 0 1 0;border-image-width:0 0 1px 0;box-sizing:border-box;content:\"\";display:block;height:calc(1em + 2px);margin-top:-.5em;position:absolute;top:50%;width:100%;z-index:-1}.mcdd17991f_link:active .mcdd17991f_linkLabel:after,.mcdd17991f_link:focus .mcdd17991f_linkLabel:after,.mcdd17991f_link:hover .mcdd17991f_linkLabel:after{border-color:#006373;border-image-source:repeating-linear-gradient(90deg,#006373,#006373)}.mcdd17991f_disabled,.mcdd17991f_disabled:active,.mcdd17991f_disabled:focus,.mcdd17991f_disabled:hover,.mcdd17991f_link[disabled]{color:#706f6e!important;cursor:default!important;pointer-events:none!important;border-color:transparent!important;border-image-source:none!important}.mcdd17991f_disabled:active:after,.mcdd17991f_disabled:after,.mcdd17991f_disabled:focus:after,.mcdd17991f_disabled:hover:after,.mcdd17991f_link[disabled] .mcdd17991f_linkLabel:after,.mcdd17991f_link[disabled]:after{border-color:transparent!important;border-image-source:none!important}.mcdd17991f_underlined .mcdd17991f_linkLabel:after{border-color:#007e8c;border-image-source:repeating-linear-gradient(90deg,#007e8c,#007e8c 2px,transparent 0,transparent 4px);border-style:dashed}.mcdd17991f_bold{font-weight:700;font-size:.98em}.mcdd17991f_standalone{font-size:14px;font-weight:700;letter-spacing:1.600000023841858px;line-height:20px;text-transform:uppercase}.mcdd17991f_standalone:after{border-color:transparent;border-image-source:none}";
var linkStyles =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  'default': link,
  link: link$1,
  linkIconLabel: linkIconLabel,
  linkLabel: linkLabel,
  disabled: disabled,
  underlined: underlined,
  bold: bold,
  standalone: standalone,
  styles: styles$3
});

function create_else_block(ctx) {
  var button;
  var div0;
  var t0;
  var div1;
  var t1;
  var dls_icon_label;
  var slot0;
  var t2;
  var span;
  var slot1;
  var t3;
  var t4;
  var slot2;
  var span_class_value;
  var dls_icon_label_class_value;
  var button_class_value;
  return {
    c: function c() {
      button = element("button");
      div0 = element("div");
      t0 = space();
      div1 = element("div");
      t1 = space();
      dls_icon_label = element("dls-icon-label");
      slot0 = element("slot");
      t2 = space();
      span = element("span");
      slot1 = element("slot");
      t3 = text(
      /*label*/
      ctx[3]);
      t4 = space();
      slot2 = element("slot");
      attr(div0, "data-style", "");
      attr(div1, "data-style", "");
      attr(slot0, "name", "link-icon");
      attr(slot0, "slot", "icon-label-glyph");
      attr(slot1, "name", "link-label");
      attr(span, "class", span_class_value =
      /*style*/
      ctx[11].is("linkLabel"));
      attr(span, "slot", "icon-label-text");
      set_custom_element_data(dls_icon_label, "class", dls_icon_label_class_value =
      /*style*/
      ctx[11].is("linkIconLabel"));
      set_custom_element_data(dls_icon_label, "position",
      /*iconposition*/
      ctx[1]);
      set_custom_element_data(dls_icon_label, "space",
      /*iconspace*/
      ctx[2]);
      set_custom_element_data(dls_icon_label, "theme",
      /*_iconlabeltheme*/
      ctx[5]);
      attr(button, "class", button_class_value = "" + (
      /*style*/
      ctx[11].is("link") + " " +
      /*optionalClassNames*/
      ctx[8]));
      button.disabled =
      /*isDisabled*/
      ctx[6];
      attr(button, "type", "button");
    },
    m: function m(target, anchor) {
      insert(target, button, anchor);
      append(button, div0);
      div0.innerHTML =
      /*linkDisableHostStylesheet*/
      ctx[9];
      append(button, t0);
      append(button, div1);
      div1.innerHTML =
      /*linkStylesheet*/
      ctx[10];
      append(button, t1);
      append(button, dls_icon_label);
      append(dls_icon_label, slot0);
      append(dls_icon_label, t2);
      append(dls_icon_label, span);
      append(span, slot1);
      append(slot1, t3);
      append(span, t4);
      append(span, slot2);
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*label*/
      8) set_data(t3,
      /*label*/
      ctx[3]);

      if (dirty &
      /*iconposition*/
      2) {
        set_custom_element_data(dls_icon_label, "position",
        /*iconposition*/
        ctx[1]);
      }

      if (dirty &
      /*iconspace*/
      4) {
        set_custom_element_data(dls_icon_label, "space",
        /*iconspace*/
        ctx[2]);
      }

      if (dirty &
      /*_iconlabeltheme*/
      32) {
        set_custom_element_data(dls_icon_label, "theme",
        /*_iconlabeltheme*/
        ctx[5]);
      }

      if (dirty &
      /*optionalClassNames*/
      256 && button_class_value !== (button_class_value = "" + (
      /*style*/
      ctx[11].is("link") + " " +
      /*optionalClassNames*/
      ctx[8]))) {
        attr(button, "class", button_class_value);
      }

      if (dirty &
      /*isDisabled*/
      64) {
        button.disabled =
        /*isDisabled*/
        ctx[6];
      }
    },
    d: function d(detaching) {
      if (detaching) detach(button);
    }
  };
} // (3:0) {#if href}


function create_if_block(ctx) {
  var a;
  var div0;
  var t0;
  var div1;
  var t1;
  var dls_icon_label;
  var slot0;
  var t2;
  var span;
  var slot1;
  var t3;
  var t4;
  var slot2;
  var span_class_value;
  var dls_icon_label_class_value;
  var a_class_value;
  return {
    c: function c() {
      a = element("a");
      div0 = element("div");
      t0 = space();
      div1 = element("div");
      t1 = space();
      dls_icon_label = element("dls-icon-label");
      slot0 = element("slot");
      t2 = space();
      span = element("span");
      slot1 = element("slot");
      t3 = text(
      /*label*/
      ctx[3]);
      t4 = space();
      slot2 = element("slot");
      attr(div0, "data-style", "");
      attr(div1, "data-style", "");
      attr(slot0, "name", "link-icon");
      attr(slot0, "slot", "icon-label-glyph");
      attr(slot1, "name", "link-label");
      attr(span, "class", span_class_value =
      /*style*/
      ctx[11].is("linkLabel"));
      attr(span, "slot", "icon-label-text");
      set_custom_element_data(dls_icon_label, "class", dls_icon_label_class_value =
      /*style*/
      ctx[11].is("linkIconLabel"));
      set_custom_element_data(dls_icon_label, "position",
      /*iconposition*/
      ctx[1]);
      set_custom_element_data(dls_icon_label, "space",
      /*iconspace*/
      ctx[2]);
      set_custom_element_data(dls_icon_label, "theme",
      /*_iconlabeltheme*/
      ctx[5]);
      attr(a, "class", a_class_value = "" + (
      /*style*/
      ctx[11].is("link") + " " +
      /*optionalClassNames*/
      ctx[8]));
      attr(a, "href",
      /*href*/
      ctx[0]);
      attr(a, "rel",
      /*formattedRel*/
      ctx[7]);
      attr(a, "target",
      /*target*/
      ctx[4]);
    },
    m: function m(target, anchor) {
      insert(target, a, anchor);
      append(a, div0);
      div0.innerHTML =
      /*linkDisableHostStylesheet*/
      ctx[9];
      append(a, t0);
      append(a, div1);
      div1.innerHTML =
      /*linkStylesheet*/
      ctx[10];
      append(a, t1);
      append(a, dls_icon_label);
      append(dls_icon_label, slot0);
      append(dls_icon_label, t2);
      append(dls_icon_label, span);
      append(span, slot1);
      append(slot1, t3);
      append(span, t4);
      append(span, slot2);
    },
    p: function p(ctx, dirty) {
      if (dirty &
      /*label*/
      8) set_data(t3,
      /*label*/
      ctx[3]);

      if (dirty &
      /*iconposition*/
      2) {
        set_custom_element_data(dls_icon_label, "position",
        /*iconposition*/
        ctx[1]);
      }

      if (dirty &
      /*iconspace*/
      4) {
        set_custom_element_data(dls_icon_label, "space",
        /*iconspace*/
        ctx[2]);
      }

      if (dirty &
      /*_iconlabeltheme*/
      32) {
        set_custom_element_data(dls_icon_label, "theme",
        /*_iconlabeltheme*/
        ctx[5]);
      }

      if (dirty &
      /*optionalClassNames*/
      256 && a_class_value !== (a_class_value = "" + (
      /*style*/
      ctx[11].is("link") + " " +
      /*optionalClassNames*/
      ctx[8]))) {
        attr(a, "class", a_class_value);
      }

      if (dirty &
      /*href*/
      1) {
        attr(a, "href",
        /*href*/
        ctx[0]);
      }

      if (dirty &
      /*formattedRel*/
      128) {
        attr(a, "rel",
        /*formattedRel*/
        ctx[7]);
      }

      if (dirty &
      /*target*/
      16) {
        attr(a, "target",
        /*target*/
        ctx[4]);
      }
    },
    d: function d(detaching) {
      if (detaching) detach(a);
    }
  };
}

function create_fragment(ctx) {
  var if_block_anchor;

  function select_block_type(ctx, dirty) {
    if (
    /*href*/
    ctx[0]) return create_if_block;
    return create_else_block;
  }

  var current_block_type = select_block_type(ctx);
  var if_block = current_block_type(ctx);
  return {
    c: function c() {
      if_block.c();
      if_block_anchor = empty();
      this.c = noop;
    },
    m: function m(target, anchor) {
      if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p: function p(ctx, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          dirty = _ref2[0];

      if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
        if_block.p(ctx, dirty);
      } else {
        if_block.d(1);
        if_block = current_block_type(ctx);

        if (if_block) {
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if_block.d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}

function booleanAttributeIsTrue(attributeValue) {
  return Boolean(typeof attributeValue === "string" || attributeValue);
}

function getIsDisabled(disable) {
  return booleanAttributeIsTrue(disable);
}

function getRelKeywords(opener, rel) {
  var relKeywords = [booleanAttributeIsTrue(opener) ? "" : "noopener", rel].filter(Boolean).join(" ");
  return relKeywords.length ? relKeywords : null;
}

function instance($$self, $$props, $$invalidate) {
  var linkDisableHostStylesheet = "<style>".concat(styles, "</style>");
  var linkStylesheet = "<style>".concat(styles$3, "</style>");
  var style = new StyleUtilities(linkStyles);
  addStyles([{
    attributeName: "theme",
    attributeValue: "arrow-glyph-adjustment",
    className: "ignore",
    styles: styles$1,
    parts: {
      iconLabelGlyph: iconLabelGlyph
    }
  }, {
    attributeName: "theme",
    attributeValue: "external-link-glyph-adjustment",
    className: "ignore",
    styles: styles$2,
    parts: {
      iconLabelGlyph: iconLabelGlyph$1
    }
  }]);
  var _$$props$bold = $$props.bold,
      bold = _$$props$bold === void 0 ? false : _$$props$bold;
  var _$$props$disable = $$props.disable,
      disable = _$$props$disable === void 0 ? false : _$$props$disable;
  var _$$props$href = $$props.href,
      href = _$$props$href === void 0 ? "" : _$$props$href;
  var _$$props$iconposition = $$props.iconposition,
      iconposition = _$$props$iconposition === void 0 ? "left" : _$$props$iconposition;
  var _$$props$iconspace = $$props.iconspace,
      iconspace = _$$props$iconspace === void 0 ? "mini" : _$$props$iconspace;
  var _$$props$label = $$props.label,
      label = _$$props$label === void 0 ? "" : _$$props$label;
  var _$$props$opener = $$props.opener,
      opener = _$$props$opener === void 0 ? false : _$$props$opener;
  var _$$props$rel = $$props.rel,
      rel = _$$props$rel === void 0 ? null : _$$props$rel;
  var _$$props$standalone = $$props.standalone,
      standalone = _$$props$standalone === void 0 ? false : _$$props$standalone;
  var _$$props$target = $$props.target,
      target = _$$props$target === void 0 ? null : _$$props$target;
  var _$$props$underlined = $$props.underlined,
      underlined = _$$props$underlined === void 0 ? false : _$$props$underlined;

  var _$$props$_iconlabelth = $$props._iconlabeltheme,
      _iconlabeltheme = _$$props$_iconlabelth === void 0 ? null : _$$props$_iconlabelth;

  function getOptionalClassNames(bold, disable, standalone, underlined) {
    var optionalClassNames = [style.if("bold", booleanAttributeIsTrue(bold)), style.if("disabled", booleanAttributeIsTrue(disable)), style.if("standalone", booleanAttributeIsTrue(standalone)), style.if("underlined", booleanAttributeIsTrue(underlined))].filter(Boolean).join(" ");
    return optionalClassNames.length ? optionalClassNames : "";
  }

  $$self.$set = function ($$props) {
    if ("bold" in $$props) $$invalidate(12, bold = $$props.bold);
    if ("disable" in $$props) $$invalidate(13, disable = $$props.disable);
    if ("href" in $$props) $$invalidate(0, href = $$props.href);
    if ("iconposition" in $$props) $$invalidate(1, iconposition = $$props.iconposition);
    if ("iconspace" in $$props) $$invalidate(2, iconspace = $$props.iconspace);
    if ("label" in $$props) $$invalidate(3, label = $$props.label);
    if ("opener" in $$props) $$invalidate(14, opener = $$props.opener);
    if ("rel" in $$props) $$invalidate(15, rel = $$props.rel);
    if ("standalone" in $$props) $$invalidate(16, standalone = $$props.standalone);
    if ("target" in $$props) $$invalidate(4, target = $$props.target);
    if ("underlined" in $$props) $$invalidate(17, underlined = $$props.underlined);
    if ("_iconlabeltheme" in $$props) $$invalidate(5, _iconlabeltheme = $$props._iconlabeltheme);
  };

  var isDisabled;
  var formattedRel;
  var optionalClassNames;

  $$self.$$.update = function () {
    if ($$self.$$.dirty &
    /*disable*/
    8192) {
      $$invalidate(6, isDisabled = getIsDisabled(disable));
    }

    if ($$self.$$.dirty &
    /*opener, rel*/
    49152) {
      $$invalidate(7, formattedRel = getRelKeywords(opener, rel));
    }

    if ($$self.$$.dirty &
    /*bold, disable, standalone, underlined*/
    208896) {
      $$invalidate(8, optionalClassNames = getOptionalClassNames(bold, disable, standalone, underlined));
    }
  };

  return [href, iconposition, iconspace, label, target, _iconlabeltheme, isDisabled, formattedRel, optionalClassNames, linkDisableHostStylesheet, linkStylesheet, style, bold, disable, opener, rel, standalone, underlined];
}

var DlsLink =
/*#__PURE__*/
function (_SvelteElement) {
  _inherits(DlsLink, _SvelteElement);

  function DlsLink(options) {
    var _this;

    _classCallCheck(this, DlsLink);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DlsLink).call(this));
    init(_assertThisInitialized(_this), {
      target: _this.shadowRoot
    }, instance, create_fragment, safe_not_equal, {
      bold: 12,
      disable: 13,
      href: 0,
      iconposition: 1,
      iconspace: 2,
      label: 3,
      opener: 14,
      rel: 15,
      standalone: 16,
      target: 4,
      underlined: 17,
      _iconlabeltheme: 5
    });

    if (options) {
      if (options.target) {
        insert(options.target, _assertThisInitialized(_this), options.anchor);
      }

      if (options.props) {
        _this.$set(options.props);

        flush();
      }
    }

    return _this;
  }

  _createClass(DlsLink, [{
    key: "bold",
    get: function get() {
      return this.$$.ctx[12];
    },
    set: function set(bold) {
      this.$set({
        bold: bold
      });
      flush();
    }
  }, {
    key: "disable",
    get: function get() {
      return this.$$.ctx[13];
    },
    set: function set(disable) {
      this.$set({
        disable: disable
      });
      flush();
    }
  }, {
    key: "href",
    get: function get() {
      return this.$$.ctx[0];
    },
    set: function set(href) {
      this.$set({
        href: href
      });
      flush();
    }
  }, {
    key: "iconposition",
    get: function get() {
      return this.$$.ctx[1];
    },
    set: function set(iconposition) {
      this.$set({
        iconposition: iconposition
      });
      flush();
    }
  }, {
    key: "iconspace",
    get: function get() {
      return this.$$.ctx[2];
    },
    set: function set(iconspace) {
      this.$set({
        iconspace: iconspace
      });
      flush();
    }
  }, {
    key: "label",
    get: function get() {
      return this.$$.ctx[3];
    },
    set: function set(label) {
      this.$set({
        label: label
      });
      flush();
    }
  }, {
    key: "opener",
    get: function get() {
      return this.$$.ctx[14];
    },
    set: function set(opener) {
      this.$set({
        opener: opener
      });
      flush();
    }
  }, {
    key: "rel",
    get: function get() {
      return this.$$.ctx[15];
    },
    set: function set(rel) {
      this.$set({
        rel: rel
      });
      flush();
    }
  }, {
    key: "standalone",
    get: function get() {
      return this.$$.ctx[16];
    },
    set: function set(standalone) {
      this.$set({
        standalone: standalone
      });
      flush();
    }
  }, {
    key: "target",
    get: function get() {
      return this.$$.ctx[4];
    },
    set: function set(target) {
      this.$set({
        target: target
      });
      flush();
    }
  }, {
    key: "underlined",
    get: function get() {
      return this.$$.ctx[17];
    },
    set: function set(underlined) {
      this.$set({
        underlined: underlined
      });
      flush();
    }
  }, {
    key: "_iconlabeltheme",
    get: function get() {
      return this.$$.ctx[5];
    },
    set: function set(_iconlabeltheme) {
      this.$set({
        _iconlabeltheme: _iconlabeltheme
      });
      flush();
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["bold", "disable", "href", "iconposition", "iconspace", "label", "opener", "rel", "standalone", "target", "underlined", "_iconlabeltheme"];
    }
  }]);

  return DlsLink;
}(SvelteElement);

function create_if_block_2(ctx) {
  var dls_icon_external_link_small;
  return {
    c: function c() {
      dls_icon_external_link_small = element("dls-icon-external-link-small");
    },
    m: function m(target, anchor) {
      insert(target, dls_icon_external_link_small, anchor);
    },
    d: function d(detaching) {
      if (detaching) detach(dls_icon_external_link_small);
    }
  };
} // (19:32) 


function create_if_block_1(ctx) {
  var dls_icon_arrow_right;
  return {
    c: function c() {
      dls_icon_arrow_right = element("dls-icon-arrow-right");
    },
    m: function m(target, anchor) {
      insert(target, dls_icon_arrow_right, anchor);
    },
    d: function d(detaching) {
      if (detaching) detach(dls_icon_arrow_right);
    }
  };
} // (17:4) {#if arrow === 'left'}


function create_if_block$1(ctx) {
  var dls_icon_arrow_left;
  return {
    c: function c() {
      dls_icon_arrow_left = element("dls-icon-arrow-left");
    },
    m: function m(target, anchor) {
      insert(target, dls_icon_arrow_left, anchor);
    },
    d: function d(detaching) {
      if (detaching) detach(dls_icon_arrow_left);
    }
  };
}

function create_fragment$1(ctx) {
  var dls_link;
  var div;
  var t0;
  var slot0;
  var t1;
  var slot1;
  var span;
  var t2;
  var t3;
  var slot2;
  var dispose;

  function select_block_type(ctx, dirty) {
    if (
    /*arrow*/
    ctx[0] === "left") return create_if_block$1;
    if (
    /*arrow*/
    ctx[0] === "right") return create_if_block_1;
    if (
    /*arrow*/
    ctx[0] === "external") return create_if_block_2;
  }

  var current_block_type = select_block_type(ctx);
  var if_block = current_block_type && current_block_type(ctx);
  return {
    c: function c() {
      dls_link = element("dls-link");
      div = element("div");
      t0 = space();
      slot0 = element("slot");
      if (if_block) if_block.c();
      t1 = space();
      slot1 = element("slot");
      span = element("span");
      t2 = text(
      /*defaultLabel*/
      ctx[8]);
      t3 = space();
      slot2 = element("slot");
      this.c = noop;
      attr(div, "data-style", "");
      attr(slot0, "name", "link-icon");
      attr(slot0, "slot", "link-icon");
      attr(slot1, "name", "link-label");
      attr(slot1, "slot", "link-label");
      attr(slot2, "slot", "link-label");
      set_custom_element_data(dls_link, "disable",
      /*disable*/
      ctx[1]);
      set_custom_element_data(dls_link, "href",
      /*href*/
      ctx[2]);
      set_custom_element_data(dls_link, "iconposition",
      /*arrowPosition*/
      ctx[7]);
      set_custom_element_data(dls_link, "iconspace", "tiny");
      set_custom_element_data(dls_link, "label",
      /*defaultLabel*/
      ctx[8]);
      set_custom_element_data(dls_link, "opener",
      /*opener*/
      ctx[3]);
      set_custom_element_data(dls_link, "rel",
      /*rel*/
      ctx[4]);
      set_custom_element_data(dls_link, "standalone", "standalone");
      set_custom_element_data(dls_link, "target",
      /*target*/
      ctx[5]);
      set_custom_element_data(dls_link, "_iconlabeltheme",
      /*iconLabelTheme*/
      ctx[9]);
    },
    m: function m(target, anchor) {
      insert(target, dls_link, anchor);
      append(dls_link, div);
      div.innerHTML =
      /*linkDisableHostStylesheet*/
      ctx[10];
      append(dls_link, t0);
      append(dls_link, slot0);
      if (if_block) if_block.m(slot0, null);
      append(dls_link, t1);
      append(dls_link, slot1);
      append(slot1, span);
      append(span, t2);
      /*span_binding*/

      ctx[13](span);
      append(dls_link, t3);
      append(dls_link, slot2);
      dispose = listen(slot2, "slotchange",
      /*checkForSlotted*/
      ctx[11]);
    },
    p: function p(ctx, _ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          dirty = _ref2[0];

      if (current_block_type !== (current_block_type = select_block_type(ctx))) {
        if (if_block) if_block.d(1);
        if_block = current_block_type && current_block_type(ctx);

        if (if_block) {
          if_block.c();
          if_block.m(slot0, null);
        }
      }

      if (dirty &
      /*defaultLabel*/
      256) set_data(t2,
      /*defaultLabel*/
      ctx[8]);

      if (dirty &
      /*disable*/
      2) {
        set_custom_element_data(dls_link, "disable",
        /*disable*/
        ctx[1]);
      }

      if (dirty &
      /*href*/
      4) {
        set_custom_element_data(dls_link, "href",
        /*href*/
        ctx[2]);
      }

      if (dirty &
      /*arrowPosition*/
      128) {
        set_custom_element_data(dls_link, "iconposition",
        /*arrowPosition*/
        ctx[7]);
      }

      if (dirty &
      /*defaultLabel*/
      256) {
        set_custom_element_data(dls_link, "label",
        /*defaultLabel*/
        ctx[8]);
      }

      if (dirty &
      /*opener*/
      8) {
        set_custom_element_data(dls_link, "opener",
        /*opener*/
        ctx[3]);
      }

      if (dirty &
      /*rel*/
      16) {
        set_custom_element_data(dls_link, "rel",
        /*rel*/
        ctx[4]);
      }

      if (dirty &
      /*target*/
      32) {
        set_custom_element_data(dls_link, "target",
        /*target*/
        ctx[5]);
      }

      if (dirty &
      /*iconLabelTheme*/
      512) {
        set_custom_element_data(dls_link, "_iconlabeltheme",
        /*iconLabelTheme*/
        ctx[9]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(dls_link);

      if (if_block) {
        if_block.d();
      }
      /*span_binding*/


      ctx[13](null);
      dispose();
    }
  };
}

var DEFAULT_LEFT_LABEL = "Back";

function instance$1($$self, $$props, $$invalidate) {
  try {
    window.customElements.define("dls-link", DlsLink);
  } catch (error) {} // TODO: See https://github.com/collectivehealth/dls/issues/552


  var linkDisableHostStylesheet = "<style>".concat(styles, "</style>");
  var namedDefaultLabel; // TODO: maybe DRY with other; similar but slightly different case

  function checkForSlotted() {
    var slot = this;
    var slotted = slot.assignedNodes({
      flatten: true
    });
    var isDefaultLeftLabel = new RegExp("^".concat(DEFAULT_LEFT_LABEL, "$"), "i").test(namedDefaultLabel.innerText);

    if (isDefaultLeftLabel && slotted.length) {
      var hasContents = Boolean(slotted.reduce(function () {
        var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var el = arguments.length > 1 ? arguments[1] : undefined; // Count elements and text nodes

        if (el.classList || el.textContent.trim().length) {
          return result + 1;
        }

        return result;
      }, 0));

      if (hasContents) {
        $$invalidate(6, namedDefaultLabel.style.display = "none", namedDefaultLabel);
      }
    }
  }

  var _$$props$arrow = $$props.arrow,
      arrow = _$$props$arrow === void 0 ? "left" : _$$props$arrow;
  var disable = $$props.disable;
  var href = $$props.href;
  var _$$props$label = $$props.label,
      label = _$$props$label === void 0 ? "" : _$$props$label;
  var opener = $$props.opener;
  var rel = $$props.rel;
  var target = $$props.target;

  function span_binding($$value) {
    binding_callbacks[$$value ? "unshift" : "push"](function () {
      $$invalidate(6, namedDefaultLabel = $$value);
    });
  }

  $$self.$set = function ($$props) {
    if ("arrow" in $$props) $$invalidate(0, arrow = $$props.arrow);
    if ("disable" in $$props) $$invalidate(1, disable = $$props.disable);
    if ("href" in $$props) $$invalidate(2, href = $$props.href);
    if ("label" in $$props) $$invalidate(12, label = $$props.label);
    if ("opener" in $$props) $$invalidate(3, opener = $$props.opener);
    if ("rel" in $$props) $$invalidate(4, rel = $$props.rel);
    if ("target" in $$props) $$invalidate(5, target = $$props.target);
  };

  var arrowPosition;
  var defaultLabel;
  var iconLabelTheme;

  $$self.$$.update = function () {
    if ($$self.$$.dirty &
    /*arrow*/
    1) {
      $$invalidate(7, arrowPosition = arrow === "external" ? "right" : arrow);
    }

    if ($$self.$$.dirty &
    /*label, arrow*/
    4097) {
      $$invalidate(8, defaultLabel = !label && arrow === "left" ? DEFAULT_LEFT_LABEL : label);
    }

    if ($$self.$$.dirty &
    /*arrow*/
    1) {
      $$invalidate(9, iconLabelTheme = arrow === "external" ? "external-link-glyph-adjustment" : "arrow-glyph-adjustment");
    }
  };

  return [arrow, disable, href, opener, rel, target, namedDefaultLabel, arrowPosition, defaultLabel, iconLabelTheme, linkDisableHostStylesheet, checkForSlotted, label, span_binding];
}

var DlsLink_1 =
/*#__PURE__*/
function (_SvelteElement) {
  _inherits(DlsLink_1, _SvelteElement);

  function DlsLink_1(options) {
    var _this;

    _classCallCheck(this, DlsLink_1);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DlsLink_1).call(this));
    init(_assertThisInitialized(_this), {
      target: _this.shadowRoot
    }, instance$1, create_fragment$1, safe_not_equal, {
      arrow: 0,
      disable: 1,
      href: 2,
      label: 12,
      opener: 3,
      rel: 4,
      target: 5
    });

    if (options) {
      if (options.target) {
        insert(options.target, _assertThisInitialized(_this), options.anchor);
      }

      if (options.props) {
        _this.$set(options.props);

        flush();
      }
    }

    return _this;
  }

  _createClass(DlsLink_1, [{
    key: "arrow",
    get: function get() {
      return this.$$.ctx[0];
    },
    set: function set(arrow) {
      this.$set({
        arrow: arrow
      });
      flush();
    }
  }, {
    key: "disable",
    get: function get() {
      return this.$$.ctx[1];
    },
    set: function set(disable) {
      this.$set({
        disable: disable
      });
      flush();
    }
  }, {
    key: "href",
    get: function get() {
      return this.$$.ctx[2];
    },
    set: function set(href) {
      this.$set({
        href: href
      });
      flush();
    }
  }, {
    key: "label",
    get: function get() {
      return this.$$.ctx[12];
    },
    set: function set(label) {
      this.$set({
        label: label
      });
      flush();
    }
  }, {
    key: "opener",
    get: function get() {
      return this.$$.ctx[3];
    },
    set: function set(opener) {
      this.$set({
        opener: opener
      });
      flush();
    }
  }, {
    key: "rel",
    get: function get() {
      return this.$$.ctx[4];
    },
    set: function set(rel) {
      this.$set({
        rel: rel
      });
      flush();
    }
  }, {
    key: "target",
    get: function get() {
      return this.$$.ctx[5];
    },
    set: function set(target) {
      this.$set({
        target: target
      });
      flush();
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["arrow", "disable", "href", "label", "opener", "rel", "target"];
    }
  }]);

  return DlsLink_1;
}(SvelteElement);

var elements = [{
  tagName: 'dls-link',
  customElement: DlsLink
}, {
  tagName: 'dls-arrow-link',
  customElement: DlsLink_1
}];
elements.forEach(function (_ref) {
  var tagName = _ref.tagName,
      customElement = _ref.customElement; // TODO: create shared utility later
  // TODO: don't call by default later, will be breaking change

  try {
    window.customElements.define(tagName, customElement);
  } catch (error) {// TODO: See https://github.com/collectivehealth/dls/issues/552
  }
});
export default DlsLink;
export { DlsLink_1 as DlsArrowLink, DlsLink };